import { makeStyles } from "@mui/styles";
import colors from "../../constants/colors";

export const useStyles = makeStyles(() => ({
  popoverPaper: {
    marginTop: "0.5rem",
    borderRadius: "0.5rem",
    boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
  },
  textField: {
    backgroundColor: colors.white,
  },
  calendarAdornment: {
    color: "rgba(0, 0, 0, 0.54)",
    cursor: "pointer",
  },
}));

export default useStyles;
